import axios from 'axios';
import type { InvoiceSearchFilters } from '../../Router/pages/BillingInvoicesPage/components/InvoicesCard/types';

export type InvoicesInfo = {
  __typename: 'BillingInfo';
  orgId: string;
  email: string | null;
  invoices: {
    edges: {
      node: {
        __typename: 'Invoice';
        stripeInvoiceId: string;
        amount: number;
        createdAt: Date;
        invoiceNumber: string | null;
        receiptNumber: string | null;
        status:
          | 'deleted'
          | 'draft'
          | 'open'
          | 'paid'
          | 'uncollectible'
          | 'void';
        stripeCustomerId: string | null;
        url: string | null;
        subscriptionType: string | null;
      };
    }[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean | null;
      startCursor: string | null;
      endCursor: string | null;
    };
  };
};

export type InvoiceData = InvoicesInfo['invoices']['edges'][number]['node'];

type GetInvoicesParams = {
  orgId: string;
  userId?: string;
  filters?: InvoiceSearchFilters;
  first?: number;
  after?: string;
};

export const getInvoices = async ({
  orgId,
  userId,
  filters,
  first,
  after,
}: GetInvoicesParams) => {
  const { data: invoices } = await axios.get<InvoicesInfo>(
    `/billing/invoices`,
    {
      params: {
        orgId,
        userId,
        filters,
        first,
        after,
      },
    },
  );

  return invoices;
};
